const styles = {
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2
  },
  modalBodyText: {
    mt: 2,
    mb: 4
  },
  confettiEmoji: {
    fontSize: '4rem',
    lineHeight: 1
  },
  openInNewIcon: {
    ml: 1,
    color: 'white !important'
  },
  primaryButton: {
    textTransform: 'none',
    backgroundColor: 'brand.accent',
    color: 'brand.main',
    '&:hover': { backgroundColor: 'brand.accentLight' }
  },
  secondaryButton: {
    textTransform: 'none',
    backgroundColor: 'brand.secondary',
    color: 'brand.white',
    '&:hover': { backgroundColor: 'brand.secondaryLight' }
  },
  progressBarContainer: {
    width: '100%',
    my: 2
  },
  progressBar: {
    height: '12px',
    borderRadius: '8px',
    backgroundColor: 'brand.accent',
    '& .MuiLinearProgress-bar': {
      borderRadius: '8px',
      backgroundColor: 'brand.secondary'
    }
  }
};

export default styles;
